module.exports = __webpack_public_path__ + "img/stairs.d796a39d.svg";